module.exports = __webpack_public_path__ + "img/weibo.54090cc3.svg";